import * as React from 'react';

import {formatTimestampForScheduledMail} from 'nutshell-core/date-time/formatting';

import type {SpecialState} from 'shells/list-view/list-view';
import {ListViewPaginatedDeprecated} from 'shells/list-view/list-view-paginated-deprecated';

import styles from './email-list.module.css';

type Props = {
    isRequesting: boolean;
    isUpdating?: boolean;
    onFetchMoreRows: () => Promise<any>;
    hasNextPage: boolean;
    collection: any[];
    renderRow: (email: any, isFirstOfDate: boolean) => React.ReactElement;
    specialStates: SpecialState[];
};

export class EmailList extends React.PureComponent<Props> {
    render() {
        return (
            <div className={styles['email-list']}>
                {/* @ts-expect-error */}
                <ListViewPaginatedDeprecated
                    specialStates={this.props.specialStates}
                    isLoading={this.props.isRequesting}
                    renderRow={this.handleRenderRow}
                    isUpdating={this.props.isUpdating}
                    collection={this.props.collection}
                    onFetchMoreRows={this.props.onFetchMoreRows}
                    hasNextPage={this.props.hasNextPage}
                />
            </div>
        );
    }

    handleRenderRow = (emailItem: any, index: number) => {
        if (emailItem.__typename === 'DateHeader') {
            return (
                <div key={index} className={styles['date-header']}>
                    {formatTimestampForScheduledMail(emailItem.timestamp)}
                </div>
            );
        }

        const isFirstOfDate =
            this.props.collection[index - 1] &&
            this.props.collection[index - 1].__typename === 'DateHeader';

        return this.props.renderRow(emailItem, isFirstOfDate);
    };
}
